<template>
  <div class="row">
    <div class="col-sm-12"><br>
      <div
        class="container-fluid col-md-5"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
      
           <br> <h1 class="text-center"><b>Menú</b></h1><br>
      
  <div id="menuRrhh" >
    <div class="d-flex justify-content-center">
		<div class="row">
			<div class="col"><br>
            <router-link :to="{ name: 'sku' }">
				<button type="submit"  id="btn1" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-box fa-2x"></i></button><br><h6>Productos</h6><br>
            </router-link>
            </div>
			<div class="col"><br>
            <router-link :to="{ name: 'list' }">
				<button type="submit"   id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-tasks fa-2x"></i></button><br><h6>Stock Productos</h6><br>
            </router-link>
            </div>
            <div class="col"><br>
            <router-link :to="{ name: 'listropa' }">
				<button type="submit"   id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-tasks fa-2x"></i></button><br><h6>Stock Ropa</h6><br>
            </router-link>
            </div>
		</div>
    </div>
    
    <div class="d-flex justify-content-center">
		<div class="row">

      <div class="col"><br>
            <u>
				<button type="submit" @click="irSolicitudes()" id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"><i class="fas fa-book fa-2x"></i></button><br><h6>Solicitudes</h6><br>
            </u>
            </div>

      <!--<div class="col"><br>
            <router-link :to="{ name: 'solicitudes' }">
				<button type="submit"   id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-book fa-2x"></i></button><br><h6>Solicitudes</h6><br>
           </router-link>
            </div>-->
			<div class="col"><br>
            <u>
				<button type="submit" @click="irVales()" id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-clipboard-check fa-2x"></i></button><br><h6>Vales</h6><br>
            </u>
            </div>
			
		</div>
    </div>
  <div class="d-flex justify-content-center">
		<div class="row">

      <div class="col"><br>
            <u>
				<button type="submit" @click="irProductos()" id="btn2" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-box-open fa-2x"></i></button><br><h6>Entregar P.</h6><br>
            </u>
            </div>

		<!--	<div class="col"><br>
            <router-link :to="{ name: 'entregaproductos' }">
				<button type="submit"   id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-box-open fa-2x"></i></button><br><h6>Entregar P.</h6><br>
           </router-link>
            </div>-->
            <div class="col"><br>
            <router-link :to="{ name: 'cierrecaja' }">
				<button type="submit"  id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-file fa-2x"></i></button><br><h6>Caja</h6><br>
            </router-link>
            </div>
			
		</div>
    </div>
     <div class="d-flex justify-content-center">
		<div class="row">
			<div class="col"><br>
            <router-link :to="{ name: 'personal' }">
				<button type="submit"  id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-users fa-2x"></i></button><br><h6>Personal</h6><br>
            </router-link>
            </div>
			
<div class="col"><br>
            <router-link :to="{ name: 'estadisticas' }">
				<button type="submit"   id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-chart-line fa-2x"></i></button><br><h6>Datos</h6><br>
           </router-link>
            </div>
            
		</div>
    </div>
    <div class="d-flex justify-content-center">
		<div class="row">
			<div class="col"><br>
            <router-link :to="{ name: 'ropa' }">
				<button type="submit"  id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-tshirt fa-2x"></i></button><br><h6>Ropa</h6><br>
            </router-link>
            </div>

            <div class="col"><br>
            <router-link :to="{ name: 'ropaextra' }">
				<button type="submit"  id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-tshirt fa-2x"></i></button><br><h6>Ropa Extra</h6><br>
            </router-link>
            </div>     
		</div>
    </div>
    </div>
        
        <div id="menuCaja" style="display:none">
            <div class="d-flex justify-content-center">
		<div class="row">
			<div class="col"><br>
            <u>
				<button type="submit" @click="irVales()" id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-clipboard-check fa-2x"></i></button><br><h6>Vales</h6><br>
            </u>
            </div>
            <div class="col"><br>
            <router-link :to="{ name: 'cierrecaja' }">
				<button type="submit"  id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-file fa-2x"></i></button><br><h6>Caja</h6><br>
            </router-link>
            </div>
			
		</div>
    </div>
<div class="d-flex justify-content-center">
		<div class="row">
			
			<div class="col"><br>
            <router-link :to="{ name: 'list' }">
				<button type="submit"   id="btn" class="btn btn-primary btn-lg"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37);"> <i class="fas fa-tasks fa-2x"></i></button><br><h6>Stock</h6><br>
            </router-link>
            </div>
  

		</div>
    </div>

        </div>
							
       
       
       <!-- <iframe id="pdf" width="100%" height="800px"></iframe>-->
      </div>
    </div>
    <div>

   <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Asignar Folio</b></h3><br>
      
                <input type="text" id="key" v-model="key" class="form-control" placeholder="Ingrese RUT facturación" style="display:none"  >
                         
                <div class="row">
                
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT facturación</label>
                        <input type="text" id="rutF" v-model="rutFacturacion" class="form-control" placeholder="Ingrese RUT facturación" style="border-color:rgb(237,126,37)"   required>
                         </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>N° documento</label>
                        <input type="text" id="nDoc" v-model="documento" class="form-control" placeholder="Ingrese n° documento" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT titular</label>
                        <input type="text" id="rutT" v-model="rut" class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Nombre titular</label>
                        <input type="text" id="nombreT" v-model="nombreTitular" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                   
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Razón social</label>
                        <input type="text" id="razonS" v-model="razonSocial" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label>Monto del cheque</label>
                            <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="border-color:rgb(237,126,37)">$</span>
                            </div>
                           <input type="text" id="monto" v-model="monto" class="form-control" placeholder="Ingrese monto" style="border-color:rgb(237,126,37)"  required>
                        
                            </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" v-model="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editar()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>   

  <b-modal id="modal-2" size="xl" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Asignar Folio</b></h3><br>
      
                <input type="text" id="key" v-model="key" class="form-control" placeholder="Ingrese RUT facturación" style="display:none"  >
                         
                <div class="row">
                
                   <div class="col">
                    <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>FOLIO</th>
              <th>TIPO</th>
              <th>RUT</th>
              <th>NOMBRE</th>
              <th>FECHA</th>
              <th>BRUTO</th>
              <th>ASIGNAR</th>
              
            
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in FoliosSap" :key="x.key">
              <td>{{ x.FolioNum }}</td>
              <td>{{ x.TipoDoc }}</td>
              <td>{{ x.LicTradNum }}</td>
              <td>{{ x.CardName }}</td>
              <td>{{ x.Fecha }}</td>
              <td>{{ x.Bruto }}</td>
              
              <td>
                <button
                  type="button"
                  @click="agregarFolio(x.FolioNum,x.Bruto)"
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                >
                 <i class="fas fa-plus fa-2x"></i>
                </button>
              </td>
              
            </tr>
          </tbody>
        </table>
<br><br>
 <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>FOLIO</th>
              <th>MONTO</th>
              <th>QUITAR</th>
              
            
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in FoliosAsignar" :key="x.key">
              <td>{{ x.folio }}</td>
              <td>{{ x.monto }}</td>
              
              <td>
                <button
                  type="button"
                  @click="quitarFolio(x.folio,x.monto)"
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                >
                 <i class="fas fa-minus fa-2x"></i>
                </button>
              </td>
              
            </tr>
          </tbody>
        </table>
        <br>
        {{resumenFoliosAsignar}}
       <h6>Monto transferencia: ${{montoTransferencia}}</h6>
       <h6>Monto total folios asignados: ${{totalFoliosAsignar}}</h6>
       <h6>Diferencia: ${{diferenciaMontos}}</h6>
       
                   </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="guardarFolios()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Guardar</button><br><br>
                    </div>
                </div>

    </div></div>

  </b-modal>
</div>
  </div>
  
</template>

<script>
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    Vue.use(BootstrapVue)

export default {
  data() {
    return {
      Transacciones: [],
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      key:'',
        rutFacturacion:'',
        documento:'',
        rut:'',
        nombreTitular:'',
        razonSocial:'',
        monto:'',
        largo:'',
      FoliosSap:[],
      FoliosAsignar:[],
      totalFoliosAsignar:0,
      resumenFoliosAsignar:'',
      montoTransferencia:0,
      diferenciaMontos:0,
     
    };
  },
  created() {
            document.getElementById("nav").style.display="block";
            this.usuario=localStorage.usuario;
            this.sucursal=localStorage.sucursal;
            console.log(localStorage.tipoUsuario)
            this.validarUsuario();  
            
   
    
  },
  methods: {
    irVales(){
      console.log(localStorage.sucursal)
      if(localStorage.sucursal=="Centro Comercial"){
         this.$router.push('/vales')
      }else if(localStorage.sucursal=="Transportes"){
         this.$router.push('/valestransportes')
      }
    },

    irProductos(){
      console.log(localStorage.sucursal)
      if(localStorage.sucursal=="Centro Comercial"){
         this.$router.push('/entregaproductos')
      }else if(localStorage.sucursal=="Transportes"){
         this.$router.push('/entregaproductostransportes')
      }
    },
    irSolicitudes(){
      console.log(localStorage.sucursal)
      if(localStorage.sucursal=="Centro Comercial"){
         this.$router.push('/solicitudes')
      }else if(localStorage.sucursal=="Transportes"){
         this.$router.push('/solicitudestransportes')
      }
    },
    
     validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }

      },

      leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },
      asignarFolio(key,rut,monto){
        this.montoTransferencia=monto;
        this.FoliosSap=[];
        console.log(key,rut,monto)
        console.log("espere ")
                this.$bvModal.show("modal-2");
                fetch("https://silent-water-26924.pktriot.net/12/"+rut)
							.then(response => {
									return response.json()
								})

							.then(data =>this.tablaSap(data.recordset));
              //.then(data=>console.log(data))
      },
      
      tablaSap(data){
        let x=this
        console.log(data)
        data.forEach(function(dato){
          x.FoliosSap.push(dato);
        })
      },

      agregarFolio(folio,monto){
        var doc = new Object();
				doc.folio=folio
        doc.monto=monto
				this.FoliosAsignar.push(doc)
        this.totalFoliosAsignar=this.totalFoliosAsignar+monto;
        this.resumenFoliosAsignar=this.resumenFoliosAsignar+folio+" ";
        this.diferenciaMontos=this.montoTransferencia-this.totalFoliosAsignar;
      },
      quitarFolio(folio,monto){
        let x=this
        var data=this.FoliosAsignar;
        this.FoliosAsignar=[]
        data.forEach(function(dato){
          if(dato.folio==folio){
            console.log("no")
             x.diferenciaMontos=x.diferenciaMontos+monto;
             x.totalFoliosAsignar=x.totalFoliosAsignar-monto;
          }else{
            x.FoliosAsignar.push(dato)
          }
        })
        //this.totalFoliosAsignar=this.totalFoliosAsignar-monto;
        this.resumenFoliosAsignar=this.resumenFoliosAsignar.replaceAll(folio,"");

      }
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>